import React from 'react';

export default function Input({ className = '', ...props }) {
    return (
        <input
            {...props}
            className={
                'py-3 px-4 block w-full border-gray-200 text-sm focus:border-main-color focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400 ' +
                className
            }
        />
    );
}
